// extracted by mini-css-extract-plugin
module.exports = {"buffer":"HistoryBuffer_buffer__3Lp7Q","bufferActive":"HistoryBuffer_bufferActive__Uhgic","logVal":"HistoryBuffer_logVal__2TPL3"};